import { render, staticRenderFns } from "./naturalLanguage.vue?vue&type=template&id=2ab65efa&scoped=true&"
import script from "./naturalLanguage.vue?vue&type=script&lang=js&"
export * from "./naturalLanguage.vue?vue&type=script&lang=js&"
import style0 from "./naturalLanguage.vue?vue&type=style&index=0&id=2ab65efa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab65efa",
  null
  
)

export default component.exports